//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import I18n   from 'i18next';
import moment from 'moment';

class DateTime {
    static getCurrentTime = () => {
        const now         = new Date();
        const currentTime = now.getTime();

        return currentTime;
    };

    static getCurrentTimeInSeconds = () => {
        return DateTime.getCurrentTime() / 1000;
    };

    static getDaysInMilliseconds = (days) => {
        return DateTime.getHoursInMilliseconds(days * 24);
    };

    static getHoursInMilliseconds = (hours) => {
        return DateTime.getMinutesInMilliseconds(hours * 60);
    };

    static getMinutesInMilliseconds = (minutes) => {
        return DateTime.getSecondsInMilliseconds(minutes * 60);
    };

    static getSecondsInMilliseconds = (seconds) => {
        return seconds * 1000;
    };

    static getTimeString = (dateTime, fallbackText) => {
        const messageDate = moment(dateTime);

        if (messageDate.isValid()) {
            return messageDate.format(I18n.t('messageDateFormat'));
        }

        return fallbackText;
    };
}

export default DateTime;
